import React from "react";
import { connect } from "react-redux";
import classNames from "classnames";

import DatePicker from "react-datepicker";
import { isMobileOnly } from "react-device-detect";
import moment from "moment";

import { Logo, Input, NextStepButton, InputError } from "components";
import { UPDATE_INPUT, MOVE_TAB } from "actions";

class SingleInvoiceCheck extends React.Component {
  state = {
    amountError: false,
    dueDateError: false,
    issueDateError: false,
    numberError: false
  };

  updateInput = data => {
    this.setState({ amountError: data.value == 0 });
    this.props.updateInput(data);
  };
  updateNumber = data => {
    this.setState({ numberError: data.value.length === 0 });
    this.props.updateInput(data);
  };
  updateDueDate = date => {
    this.setState({ dueDateError: false });
    this.props.updateInput({
      name: "singleInvoiceDueDate",
      value: date
    });
  };
  updateIssueDate = date => {
    this.setState({ issueDateError: false });
    this.props.updateInput({
      name: "singleInvoiceIssueDate",
      value: date
    });
    if (!this.props.singleInvoiceDueDate) {
      this.props.updateInput({
        name: "singleInvoiceDueDate",
        value: moment(date).add(30, 'days').toDate()
      });
    }
  };
  moveToNextTab = () => {
    const { singleInvoiceAmount, singleInvoiceDueDate, singleInvoiceIssueDate, singleInvoiceNumber } = this.props;

    const amountError = singleInvoiceAmount === "" || singleInvoiceAmount < 1;
    const dueDateError = singleInvoiceDueDate === "" || singleInvoiceDueDate === undefined;
    const issueDateError = singleInvoiceIssueDate === "" || singleInvoiceIssueDate === undefined;
    const numberError = singleInvoiceNumber === "" || singleInvoiceNumber === undefined;

    this.setState({
      amountError,
      dueDateError,
      issueDateError,
      numberError
    });

    if (amountError || dueDateError || issueDateError || numberError) {
      return;
    }

    this.props.moveToNextTab();
  };
  render() {
    const props = this.props;
    const strings = props.domain.Strings;

    const state = this.state;
    return (
      <div className="form_steps">
        <div className="form_steps--inner flex">
          <div className="full_column">
            <Logo />
            <div className="form_content">
              <div className="form_content">
                <div className="fields_container">
                  <div className={classNames("field_block field_block--fill", { error: state.issueDateError })}>
                    <label>{strings.tabSingleInvoiceCheckIssueDateLabel}</label>
                    <DatePicker
                      className="react-datepicker-hide-blinking-cursor"
                      dateFormat="d MMMM yyyy"
                      onChange={this.updateIssueDate}
                      selected={props.singleInvoiceIssueDate}
                      withPortal={isMobileOnly} />
                    {state.issueDateError && <InputError label={strings.tabSingleInvoiceCheckIssueDateError} />}
                  </div>
                  <div className={classNames("field_block field_block--fill", { error: state.dueDateError })}>
                    <label>{strings.tabSingleInvoiceCheckDueDateLabel} </label>
                    <DatePicker
                      className="react-datepicker-hide-blinking-cursor"
                      dateFormat="d MMMM yyyy"
                      minDate={new Date()}
                      onChange={this.updateDueDate}
                      selected={props.singleInvoiceDueDate}
                      withPortal={isMobileOnly} />
                    {state.dueDateError && <InputError label={strings.tabSingleInvoiceCheckDueDateError} />}
                  </div>
                  <div className={classNames("field_block field_block--fill", { error: state.amountError })}>
                    <label>{strings.tabSingleInvoiceCheckAmountLabel}</label>
                    <Input addCommas type="number" value={props.singleInvoiceAmount} onChange={this.updateInput} name="singleInvoiceAmount" />
                    {state.amountError && <InputError label={strings.tabSingleInvoiceCheckAmountError} />}
                  </div>
                  <div className={classNames("field_block field_block--fill", { error: state.numberError })}>
                    <label>{strings.tabSingleInvoiceCheckNumberLabel}</label>
                    <Input value={props.singleInvoiceNumber} onChange={this.updateNumber} name="singleInvoiceNumber" />
                    {state.numberError && <InputError label={strings.tabSingleInvoiceCheckNumberError} />}
                  </div>
                  <NextStepButton
                    loadingText="Pricing, please wait"
                    onClick={this.moveToNextTab}
                    text={strings.tabSingleInvoiceCheckNextBtn} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
//  <Input value={props.singleInvoiceDueDate} onChange={this.updateInput} name="singleInvoiceDueDate" />

const mapStateToProps = state => {
  return {
    ...state.app
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateInput: ({ name, value }) => dispatch({ type: UPDATE_INPUT, name, value }),
    moveToNextTab: () => dispatch({ type: MOVE_TAB, dir: "next", from: ownProps.tab })
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SingleInvoiceCheck);
